
import { number } from "prop-types";

const ms233 = {
  label: "Send SMS",
  pageLabel: "Send SMS",
  starting: true,
  url: "ms233",
  pageType: "history",
  form: [
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-7",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-5",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "* For Top Account Select Product",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-1",
        children: "col-sm-12"
      },
      placeHolder: "Region",
      label: "Region",
      name: "",
      description: "Enter Region"
    },
    {
      inputType: "autocomplete",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "region-1",
          value: "region-1"
        },
        {
          label: "region-2",
          value: "region-2"
        },
        {
          label: "region-3",
          value: "region-3"
        }
      ],
      placeHolder: "Region",
      //   label: "Region",
      name: "region",
      description: "Enter Region"
    },
    {
      inputType: "showdata",
      tab: "filter",
      data: "region",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "select",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "option-1",
          value: "option-1"
        },
        {
          label: "option-2",
          value: "option-2"
        },
        {
          label: "option-3",
          value: "option-3"
        }
      ],
      placeHolder: "option1",
      //   label: "option1",
      name: "option1",
      description: "Enter option1"
    },
    {
      inputType: "checkbox",
      tab: "filter",
      default: true,
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Print Marathi Name",
      label: "Print Marathi Name",
      name: "Print Marathi Name",
      description: "Print Marathi Name"
    },

    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-1",
        children: "col-sm-12"
      },
      placeHolder: "Parent Branch",
      label: "Parent Branch",
      name: "Parentbranch",
      description: "Enter Parent Branch"
    },
    {
      inputType: "autocomplete",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "branch-1",
          value: "branch-1"
        },
        {
          label: "branch-2",
          value: "branch-2"
        },
        {
          label: "branch-3",
          value: "branch-3"
        }
      ],
      placeHolder: "Branch Code",
      //   label: "Branch Code",
      name: "branch",
      description: "Enter branch code"
    },
    {
      inputType: "showdata",
      tab: "filter",
      data: "branch",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "select",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "option-1",
          value: "option-1"
        },
        {
          label: "option-2",
          value: "option-2"
        },
        {
          label: "option-3",
          value: "option-3"
        }
      ],
      placeHolder: "option1",
      //   label: "option1",
      name: "option1",
      description: "Enter option1"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-1",
        children: "col-sm-12"
      },
      placeHolder: "Product Group",
      label: "Product Group",
      name: "",
      description: "Enter Product Group"
    },
    {
      inputType: "autocomplete",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "Product Group-1",
          value: "Product Group-1"
        },
        {
          label: "Product Group-2",
          value: "Product Group-2"
        },
        {
          label: "Product Group-3",
          value: "Product Group-3"
        }
      ],
      placeHolder: "Product Group",
      //   label: "Region",
      name: "productGroup",
      description: "Enter Product Group"
    },
    {
      inputType: "showdata",
      tab: "filter",
      data: "productGroup",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "select",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "option-1",
          value: "option-1"
        },
        {
          label: "option-2",
          value: "option-2"
        },
        {
          label: "option-3",
          value: "option-3"
        }
      ],
      placeHolder: "option2",
      //   label: "option1",
      name: "option2",
      description: "Enter option2"
    },
    {
      inputType: "checkbox",
      tab: "filter",
      default: true,
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Print Member No",
      label: "Print Member No",
      name: "Print Member No",
      description: "Print Member No"
    },
    {
      inputType: "displaytext",
      widths: {
        parent: "col-sm-1",
        children: "col-sm-12"
      },
      placeHolder: "Code",
      label: "Product Type",
      name: "Product Type",
      description: ""
    },
    {
      inputType: "autocompletemulti",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-5",
        children: "col-sm-12"
      },
      options: [
        {
          label: "product type-1",
          value: "product type-1"
        },
        {
          label: "product type-2",
          value: "product type-2"
        },
        {
          label: "product type-3",
          value: "product type-3"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getState",
          fieldType: "string",
          filters: ["pageData", "State"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "AutocompleteMulti text",
      name: "productType",
      description: "Enter Product Type"
    },
    {
      inputType: "select",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "option3-1",
          value: "option3-1"
        },
        {
          label: "option3-2",
          value: "option3-2"
        },
        {
          label: "option3-3",
          value: "option3-3"
        }
      ],
      placeHolder: "option3",
      //   label: "option1",
      name: "option3",
      description: "Enter option3"
    },
    {
      inputType: "checkbox",
      tab: "filter",
      default: true,
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Print KYC flag",
      label: "Print KYC flag",
      name: "Print KYC flag",
      description: "Print Member No"
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-1",
        children: "col-sm-12"
      },
      placeHolder: "Product",
      label: "Product",
      name: "",
      description: "Enter Product"
    },
    {
      inputType: "autocomplete",
      tab: "create",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "product1",
          value: "product1"
        },
        {
          label: "product2",
          value: "product2"
        },
        {
          label: "product3",
          value: "product3"
        }
      ],
      placeHolder: "Branch Code",
      //   label: "Branch Code",
      name: "product",
      description: "Enter 2 digit branch code"
    },
    {
      inputType: "showdata",
      tab: "create",
      data: "product",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "select",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "option3-1",
          value: "option3-1"
        },
        {
          label: "option3-2",
          value: "option3-2"
        },
        {
          label: "option3-3",
          value: "option3-3"
        }
      ],
      placeHolder: "option4",
      //   label: "option1",
      name: "option4",
      description: "Enter option4"
    },
    {
      inputType: "checkbox",
      tab: "filter",
      default: true,
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Print Aadhar",
      label: "Print Aadhar",
      name: "PrintAadhar",
      description: "Print Aadhar"
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-1",
        children: "col-sm-12"
      },
      placeHolder: "As On Date",
      label: "As On Date",
      name: "",
      description: "As On Date"
    },
    {
      inputType: "date",
      isRequired: true,
      tab: "create",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "As On Date",
      name: "AsOnDate",
      description: "As On Date"
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "select",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "option3-1",
          value: "option3-1"
        },
        {
          label: "option3-2",
          value: "option3-2"
        },
        {
          label: "option3-3",
          value: "option3-3"
        }
      ],
      placeHolder: "option5",
      //   label: "option1",
      name: "option5",
      description: "Enter option5"
    },
    {
      inputType: "checkbox",
      tab: "filter",
      default: true,
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Print PAN",
      label: "Print PAN",
      name: "PrintPAN",
      description: "Print PAN"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-1",
        children: "col-sm-12"
      },
      placeHolder: "Acc No.From",
      label: "Acc No.From",
      name: "",
      description: "Acc No.From"
    },
    {
      inputType: "numberonly",
      tab: "filter",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Acc No.From",
      name: "AccNoFrom",
      description: "Acc No.From"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Acc No.To",
      label: "Acc No.To",
      name: "",
      description: "Acc No.To"
    },
    {
      inputType: "numberonly",
      tab: "filter",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Acc No.To",
      name: "AccNoTo",
      description: "Acc No.To"
    },
    {
      inputType: "checkbox",
      tab: "filter",
      default: true,
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Print Risk Category",
      label: "Print Risk Category",
      name: "PrintRiskCategory",
      description: "Print Risk Category"
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-1",
        children: "col-sm-12"
      },
      placeHolder: "Credit/Debit Type",
      label: "Credit/Debit Type",
      name: "Credit/Debit Type",
      description: "Enter Credit/Debit Type"
    },
    {
      inputType: "select",
      tab: "create",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "credit-debit1",
          value: "credit-debit1"
        },
        {
          label: "credit-debit2",
          value: "credit-debit2"
        },
        {
          label: "credit-debit3",
          value: "credit-debit3"
        }
      ],
      placeHolder: "Credit/Debit Type",
      //   label: "Credit/Debit Type",
      name: "CreditDebitType",
      description: "Enter 2 digit Credit/Debit Type"
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-8",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-1",
        children: "col-sm-12"
      },
      placeHolder: "Amount From",
      label: "Amount From",
      name: "",
      description: "Amount From"
    },
    {
      inputType: "numberonly",
      tab: "filter",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Amount From",
      name: "AmountFrom",
      description: "Amount From"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Amount To",
      label: "Amount To",
      name: "",
      description: "Amount To"
    },
    {
      inputType: "numberonly",
      tab: "filter",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Amount To",
      name: "AmountTo",
      description: "Amount To"
    },
    {
      inputType: "checkbox",
      tab: "filter",
      default: true,
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Send SMS",
      label: "Send SMS",
      name: "SendSMS",
      description: "Send SMS"
    },
    {
      inputType: "displaytext",
      widths: {
        parent: "col-sm-1",
        children: "col-sm-12"
      },
      placeHolder: "Code",
      label: "Account Type",
      name: "Account Type",
      description: "Account Type"
    },
    {
      inputType: "autocompletemulti",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-5",
        children: "col-sm-12"
      },
      options: [
        {
          label: "account type-1",
          value: "account type-1"
        },
        {
          label: "account type-2",
          value: "account type-2"
        },
        {
          label: "account type-3",
          value: "account type-3"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getState",
          fieldType: "string",
          filters: ["pageData", "State"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "AutocompleteMulti text",
      name: "accountType",
      description: "Enter Product Type"
    },
    {
      inputType: "displaytext",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "Code",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-1",
        children: "col-sm-12"
      },
      placeHolder: "SMS",
      label: "SMS",
      name: "",
      description: "SMS"
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-5",
        children: "col-sm-12"
      },
      placeHolder: "SMS",
      name: "sms1",
      description: "SMS"
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-5",
        children: "col-sm-12"
      },
      placeHolder: "SMS",
      name: "sms2",
      description: "SMS"
    }
  ],
  history: {
    perPage: 10,
    reportHeader: "User Statement",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    displayColumns: [
      {
        Header: "Branch",
        accessor: "LoginName",
        width: 150
      },
      {
        Header: "Account Number",
        accessor: "lastname",
        width: 150
      },
      {
        Header: "CIN",
        accessor: "email"
      },
      {
        Header: "Account Name",
        accessor: "mobile"
      },
      {
        Header: "Debit",
        accessor: "pfnumber"
      },
      {
        Header: "Credit",
        accessor: "EmployeeID"
      }
    ]
  }
};

export default ms233;
